import {Facility} from './Facility';
import {StaffInformation} from './StaffInformation';
import {Attachment} from '../res/attachment';
import {BaseModel} from '../baseModel';
import {Assignee} from './Assignee';
import {AssignmentGroup} from '../res/assignment-group';

export class FacilityEmployee extends BaseModel<number> {
  facility: Facility;
  assignee: any = new Assignee();
  assignmentType = 'EMPLOYEE_ASSIGNMENT';
  assignmentGroups: AssignmentGroup[];
  staffInformation: StaffInformation = new StaffInformation();
  employeeFiles: any[] = [];
  attachments: Attachment[] = [];
  startDate: Date;
  endDate: Date;
  employeeSequence: number;
  ownerSequence: number;
  userId: number;
  override id: number;

  fakeId: number; // this fake id is only for front end side, when this employee is a owner
  isOwner: boolean;
}
